import { useState } from "react";


const Card = (props) => {
  const [selected, setSelected] = useState<boolean>(props.selected);
  const [isDebrief, setIsDebrief] = useState<boolean>(props.isDebrief);
  const handleChange = async () => {
    // if cards is selected by default, user is not allowed to deselect it
    await !props.selected && setSelected(!selected);
    props.onChange();
  };
  let last = false;
  if(selected && isDebrief){
    switch (props.label) {
      case "Tirer les rideaux":
      case "Une carafe d'eau, verre...":
      case "Radiologie de l'accident":
        //last = true;
      break;
      
      default:
      break;
    }
  }
  
  return (
    <label
      className={`ec-card ${selected && "selected"} ${props.color} ${last ? "last" : ""}`}
      onChange={handleChange}
    >
      <input type="checkbox" />
      {props.children}
    </label>
  );
};

export default Card;
